export default {
    loadError:   'Не удалось загрузить данные по статистике',
    noData:      'Данных по статистике пока нет',
    targetLeads: 'Целевые лиды',
};
